import { render, staticRenderFns } from "./PrivateVideos.vue?vue&type=template&id=5eee90ea&"
import script from "./PrivateVideos.vue?vue&type=script&lang=js&"
export * from "./PrivateVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports